import { render, staticRenderFns } from "./footbar.vue?vue&type=template&id=71c3e498&scoped=true&"
import script from "./footbar.vue?vue&type=script&lang=js&"
export * from "./footbar.vue?vue&type=script&lang=js&"
import style0 from "./footbar.vue?vue&type=style&index=0&id=71c3e498&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c3e498",
  null
  
)

export default component.exports